import { createPostAsyncSlice } from '@sonar-software/xuder';
import { getAdminFeatureFlagsSlice } from '../../get';
import { postUseDefaultAdminFeatureFlagByCustomerId } from '../../../../api';
import { removeAdminFeatureFlagCustomerSlice } from '../../remove';
import { UseDefaultAdminFeatureFlagName } from './name';

export const useDefaultAdminFeatureFlagByCustomerIdSlice = createPostAsyncSlice({
	httpSagaOptions: {
		preRequestActionCreators: [
			removeAdminFeatureFlagCustomerSlice.syncActionCreator
		],
		successActionCreators: [
			getAdminFeatureFlagsSlice.asyncActionCreators.repeatGetAdminFeatureFlags
		]
	},
	name: UseDefaultAdminFeatureFlagName,
	receive: false,
	request: true,
	requestHandler: postUseDefaultAdminFeatureFlagByCustomerId
});
